// extracted by mini-css-extract-plugin
export default {"tab-container":"E_Ifq3Oh"};